// Local translations
export const T = {
  en_GB: {
    editFlow: "Edit Flow",
    createNewFlow: "Create New Flow",
    editFlowDescription: "Update the flow information below.",
    createFlowDescription: "Create a new flow. You'll be able to add pages and fields next.",
    flowName: "Flow Name",
    flowNamePlaceholder: "e.g., Onboarding Process",
    description: "Description",
    descriptionPlaceholder: "Optional description of what this flow is for",
    language: "Language",
    selectLanguage: "Select language",
    languageCannotBeChanged: "Language cannot be changed after creation",
    currency: "Currency",
    currencyHint: "Amounts in this flow use this currency. It can't be changed later.",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    failedToSaveFlow: "Failed to save flow",
  },
  nb_NO: {
    editFlow: "Rediger flyt",
    createNewFlow: "Opprett ny flyt",
    editFlowDescription: "Oppdater flytinformasjonen nedenfor.",
    createFlowDescription: "Opprett en ny flyt. Du kan legge til sider og felt etterpå.",
    flowName: "Flytnavn",
    flowNamePlaceholder: "f.eks. Onboarding-prosess",
    description: "Beskrivelse",
    descriptionPlaceholder: "Valgfri beskrivelse av hva denne flyten er for",
    language: "Språk",
    selectLanguage: "Velg språk",
    languageCannotBeChanged: "Språk kan ikke endres etter opprettelse",
    currency: "Valuta",
    currencyHint: "Beløp i denne flyten bruker denne valutaen. Den kan ikke endres senere.",
    cancel: "Avbryt",
    save: "Lagre",
    create: "Opprett",
    failedToSaveFlow: "Kunne ikke lagre flyt",
  },
} as const;
